import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';
import Swiper from 'swiper';
// import { Navigation, Pagination, Autoplay, Grid } from 'swiper/modules';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
//  import 'swiper/css/grid';

Swiper.use([Navigation, Pagination, Autoplay]);
import 'swiper/css';



document.addEventListener('DOMContentLoaded', () => {

  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }
 const commonConfig = {
  itemSelectText: 'Выбрать',
  searchPlaceholderValue: 'Поиск...',
  noResultsText: 'Не найдено...',
  searchEnabled: false,
    shouldSort: false,
};
const selectors = [
  { selector: '.f-brand', options: { searchEnabled: true } },
  { selector: '.f-model', options: { searchEnabled: false } },
]; 


const choicesInstances = {};


  selectors.forEach(({ selector, options = {} }) => {
    const element = document.querySelector(selector);
    if (element) {
      choicesInstances[selector] = new Choices(element, { 
        ...commonConfig, 
        ...options 
      });
    }
  });



const brandElement = document.querySelector('.f-brand');
    brandElement.addEventListener('change', debounce(async (e) => {
      const brandId = e.detail.value;
      const modelChoices = choicesInstances['.f-model'];
      modelChoices.removeActiveItems();
    // modelChoices.setChoices([{ value: '', label: 'Ошибка загрузки', disabled: true }]);

      try {
        const response = await fetch(`/api/models?brand_id=${brandId}`);
        const models = await response.json();
        if (models.data.length > 0) {
          modelChoices.setChoices(
            models.data.map(model => ({
              value: model.id,
              label: model.name
            })),
            'value',
            'label',
            true
          );
        } else {
          modelChoices.setChoices([{ value: '', label: 'Нет моделей для этого бренда', disabled: true }]);
        }
      } catch (error) {
        console.error('Error loading models:', error);
        modelChoices.setChoices([{ value: '', label: 'Ошибка загрузки', disabled: true }]);
      }
    }));


  if (choicesInstances['.f-model']) {
    choicesInstances['.f-model'].setChoices(
      [{ value: '', label: 'Сначала выберите бренд', disabled: true }],
      'value',
      'label',
      true
    );
  }

const modelElement = document.querySelector('.f-model');

     const swiperWrapper = document.querySelector('.swiper-wrapper');
     const swiperButtons = document.querySelector('.swiper-buttons');







  modelElement.addEventListener('change', debounce(async (e) => {
      const modelId = e.detail.value;


  try {
    swiperWrapper.innerHTML = '<div class="loading">Загрузка...</div>';
  const response = await fetch(`/api/get-cars-by-model-id`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ modelId }),
  });

  if (!response.ok) {
    const errorText = await response.text(); // Читаем текст ошибки
    throw new Error(`HTTP error! Status: ${response.status}, Response: ${errorText}`);
  }

  const models = await response.json(); // Парсим JSON только если ответ успешный
  if (models.data.length > 0) {
      swiperButtons.style.opacity = 1;
  // Контейнер слайдов
      swiperWrapper.innerHTML = '';

        models.data.forEach((car) => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.innerHTML = `
          <div class="car-card">
            <div class="car-card-choise"></div>
            <div class="car-card-id">№ ${car.xml_id}</div>
            <img src="/iwebp/${car.id}/${car.first_photo}-sm.webp" alt="${car.name}">
            <div class="car-card-title">${car.brandName} ${car.model} ${car.modification}</div>
            <div class="car-card-price"> ${car.discount_price} ₽</div>
            <p> ${car.year} г., Пробег: ${car.mileage} км</p>
            <p>${car.modification}, ${car.transmission}, ${car.drive} </p>
           </div>
        `;
        swiperWrapper.appendChild(slide);
      
      });

      const activeSlide = document.querySelector('.car-card');
      activeSlide.classList.add('active');
      activeSlide.click();
        if (window.carSwiper) {carSwiper
        window.carSwiper.update(); // Если Swiper уже есть
      } else {
        window.carSwiper = new Swiper('.credit-swiper', {
                loop: true,
            slidesPerView: 2,
            spaceBetween: 30,
              grid: {
        rows: 2,
      },
                  pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
  on: {
    activeIndexChange: function () {
      updateActiveCarCard(this.activeIndex);
    },
  },
 
          navigation: { nextEl: '.swiper-button-n', prevEl: '.swiper-button-p' },
                                     breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
        
    },
      768: {
      slidesPerView: 3,
    },
  },
        });
      }


  } else {
    // Нет данных
  }
} catch (error) {
  console.error('Error:', error);
  // Показываем пользователю ошибку
}
    }));



function updateActiveCarCard(activeIndex) {
  // Убираем активный класс у всех карточек
  document.querySelectorAll('.credit-swiper .car-card').forEach((card) => {
    card.classList.remove('active');
  });

  // Находим текущий слайд и добавляем класс его car-card
  const currentSlide = document.querySelectorAll('.swiper-slide')[activeIndex];
  if (currentSlide) {
    const carCard = currentSlide.querySelector('.car-card');
    if (carCard) {
      carCard.classList.add('active');
      carCard.click();
    }
  }
}


document.querySelector('.swiper-cont').addEventListener('click', function(event) {
      if (event.target.closest('.car-card')) {
          const cards = document.querySelectorAll('.car-card');
          cards.forEach(ctx => {
            ctx.classList.remove('active');

          })


        event.target.closest('.car-card').classList.toggle('active');
        const price = event.target.closest('.car-card').querySelector('.car-card-price').textContent;
        const carID = event.target.closest('.car-card').querySelector('.car-card-id').textContent;
          const userChoice = document.querySelector('.user-choice');
          userChoice.textContent = carID;
        // sumSlider.noUiSlider.set(returnOnlyNumbers(price))
        let model =   choicesInstances['.f-model'].getValue();
        let brand =   choicesInstances['.f-brand'].getValue();
        //  carInput.value = model.label;
        //  brandInput.value = brand.label;
    }
    
    // Альтернативный вариант проверки по тегу
    // if (event.target.tagName === 'BUTTON') {
    //     // Обработка клика по кнопке
    // }
});




function handleCarRequest() {
  const title = document.querySelector('.car-card.active .car-card-title').textContent;    
  const price = document.querySelector('.car-card.active .car-card-price').innerHTML;

  
  const info = `<div class="flex">
    <div class="text">
        <div class="title">${title}</div>
        <div class="price">${price}</div>
    </div>
  </div>`;

  const params = {
    title: 'Приобрести в кредит:',
    info: info,
    message: title,
    type: 'credit_page_modal'
  };
  
  // showModalForm(params);
}




});
